const BLOCKED_SUBSTRINGS = [
  "1bbff9ce-88de-494d-8617-54486b4a3af7", // broken firebase object
];

const FALLBACK_IMG = "/images/sliders/1.webp";

export function sanitizeImageUrl(url?: string | null): string {
  if (!url) return FALLBACK_IMG;
  const normalized = url.trim();
  if (!normalized) return FALLBACK_IMG;
  if (BLOCKED_SUBSTRINGS.some((bad) => normalized.includes(bad))) {
    return FALLBACK_IMG;
  }
  return normalized;
}

export function fallbackImage(): string {
  return FALLBACK_IMG;
}
